/**
 * The UserContextProvider component is used to provide the user details to any component which needs it.
 *
 * @module views/__core/UserContextProvider/UserContextProvider
 */
import React, { useState, useContext, createContext, useEffect, useRef } from 'react';
const { LOGIN_STATUS } = require( '../../../utils/constants/constants' ).default;
/**
  * Represents a UserContextProvider component
  *
  * @method
  * @param { Object } props - React properties passed from composition
  * @returns UserContextProvider
  */
export const UserContextProvider = function( { children } ){
  const [user, setUser] = useState(
    {
      gti: global.globalPageData?.profile?.GTI,
      firstName: global.globalPageData?.profile?.firstName,
      userType: global.globalPageData?.rewards?.userType,
      platinumMember: global.globalPageData?.rewards?.platinumMember,
      loginType: global.globalPageData?.profile?.GTI && ( global.globalPageData.profile.firstName ? LOGIN_STATUS.HARD_LOGIN : LOGIN_STATUS.ANONYMOUS )
    } );
  const prevUserRef = useRef();
  useEffect( () => {
    prevUserRef.current = user;
    if( !global.globalPageData?.profile?.GTI ){
      const checkGlobalId = setInterval( () => {
        const updatedUser = {
          gti: global.globalPageData?.profile.GTI,
          firstName: global.globalPageData?.profile.firstName,
          userType: global.globalPageData?.rewards?.userType,
          platinumMember: global.globalPageData?.rewards?.platinumMember,
          loginStatus: !!global.globalPageData?.profile.firstName,
          loginType: global.globalPageData?.profile.firstName ? LOGIN_STATUS.HARD_LOGIN : LOGIN_STATUS.ANONYMOUS
        }
        if( updatedUser.gti && prevUserRef.current && !( prevUserRef.current.gti === updatedUser.gti && prevUserRef.current.firstName === updatedUser.firstName && prevUserRef.current.userType === updatedUser.userType && prevUserRef.current.platinumMember === updatedUser.platinumMember ) ){
          setUser( { ...updatedUser } );
        }
      }, 100 );
    }
  }, [user] );
  return (
    <UserContext.Provider value={ user } >
      { children }
    </UserContext.Provider>
  )
}
export default UserContextProvider;
/**
  * Context provider for react reuse
  * @type object
  */
export const UserContext = createContext();
/**
  * contxt provider
  * @type object
  */
export const useUserContext = ( ) => useContext( UserContext );